import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../config/config';
@Injectable({
  providedIn: 'root'
})
export class GralMonService {

  dataUrl = Config.URL_BASE;

  constructor(
    private http: HttpClient
  ) { }

  catalogo(criterio: PageBusquedaObject): Observable<any> {
    let url_ = this.dataUrl + '/gralmon/catalogo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criterio).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  post(dto: GralMon): Observable<any> {
    let url_ = this.dataUrl + '/gralmon/post';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  delete(id: number, idUsr: number): Observable<any> {
    const url_ = this.dataUrl + '/gralmon/delete/' + id + '/' + idUsr;
    return this.http.delete(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  put(dto: GralMon): Observable<any> {
    let url_ = this.dataUrl + '/gralmon/put';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getMoneda(id: number): Observable<any> {
    let url_ = this.dataUrl + '/gralmon/get/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getSatMoneda(clave: String): Observable<any> {
    let url_ = '';
    if (clave !== '') {
      url_ = this.dataUrl + '/gralmon/get/smoneda/' + clave;
    } else {
      url_ = this.dataUrl + '/gralmon/get/smoneda/0';
    }
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

}

export class GralMon {
  id: number;
  descripcion: String;
  nomSingular: String;
  gral_emp_id: number;
  nomPlural: String;
  simbolo: String
  compras: boolean;
  ventas: boolean;
  claveSat: SatMon;
  no_dec: number;
  momento_crea: String;
  momento_actualiza: String;
  momento_baja: String;
  gralUsrCreaId: number;
  gralUsrActualizaId: number;
  gralUsrBajaId: number;
  claveS: String;
  serie_bmx: String;
}

export class SatMon {
  id: number;
  clave: String;
  decimales: number;
  descripcion: String;
}

export class PageBusquedaObject {
  column?: string | undefined;
  criteriaSearch?: any | undefined;
  itemsPerPage?: number | undefined;
  order?: string | undefined;
  pageNumber?: number | undefined;
  sort?: boolean | undefined;
}
